import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textFilter'
})
export class TextFilterPipe implements PipeTransform {
  transform(data: any[], filterType: string, value: string, obj?: string): any {
    if (!data || !filterType || !value) {
      return data;
    }

    if (!obj) {
      return data.filter(item => item[filterType].indexOf(value) !== -1);
    }
    return data.filter(item => item[obj][filterType].indexOf(value) !== -1);
  }
}
